import apiService from '../../services/api';

const actions = {
    upload: (context, params) => {
        return apiService.postForm('file.upload', params);
    },
    download: (context, params) => {
        return apiService.get('file.download', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    actions,
    mutations
};
